module.exports = __webpack_public_path__ + "img/door-left.0ecc8c77.svg";